export default  class MicrosoftManager {
  
  static __initStatic() {this.SCOPE = 'openid email profile'}
  

  constructor(accessToken) {
    this.accessToken = accessToken
  }
} MicrosoftManager.__initStatic();
